export default __webpack_public_path__ + "static/media/logo.287f1dda.png";